import { Injectable } from '@angular/core';
import { MainService } from './main.service';
import { UsersService } from './users.service';
import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class StationsService {

  constructor(
    private usrService : UsersService,
    private main: MainService
  ) { }

  getStationData() : any {
    return this.main.getRequest("/packing/station/");
  }

  getBoxData(box_id: string) {
    return this.main.getRequest("/packing/boxscan/" + box_id);
  }

  setBoxStatus(box_obj: any) {
    return this.main.postRequest(box_obj, "/packing/boxscan");
  }

  setBoxCompleted(box_obj: any) {
    return this.main.postRequest(box_obj, "/packing/boxscan/completed");
  }

  setBoxValidated(box_obj: any) {
    return this.main.postRequest(box_obj, "/packing/boxscan/validated");
  }

  uploadBoxVideo(form : FormData){
    return this.main.postRequestFormData(form, "/packing/boxscan/video/upload");
  }

  setPtlCall(obj: any) {
    return this.main.postRequest(obj, "/packing/sendPtlCall");
  }

  setVisionCall(obj: any) {
    return this.main.postRequest(obj, "/packing/sendVisionCall");
  }
  
  getMaterialValidaQr(mat_id: any, id_campana: any, tipo: any) {
    return this.main.getRequest("/packing/boxscan/validaqr/" + mat_id + '/' + id_campana + '/' + tipo);
  }

  getValidaQrScanned(obj: any) {
    return this.main.postRequest(obj, "/packing/boxscan/validaqr_scanned");
  }

  setValidaQrScanned(obj: any) {
    return this.main.postRequest(obj, "/packing/boxscan/set_qr_scanned");
  }
  
  setError(box_obj: any) {
    return this.main.postRequest(box_obj, "/packing/boxscan/error");
  }

  setOutoffline(box_id: any) {
    return this.main.getRequest("/packing/boxscan/outoffline/" + box_id);
  }

  setLogErrorVideo(box_id: any, id_campana: any){
    return this.main.getRequest("/packing/logErrorVideo/" + box_id + "/" + id_campana);
  }
}
